// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-wrapper[data-v-155babc1]{margin-left:auto;margin-right:auto}", "",{"version":3,"sources":["webpack://./src/js/components/apply-wizard/steps/FinancesLoanPayments.vue"],"names":[],"mappings":"AACA,kCACI,gBAAA,CACA,iBAAJ","sourcesContent":["\n.section-wrapper {\n    margin-left: auto;\n    margin-right: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
